import React from 'react'
import styles from './BackButton.module.scss'
import { ReactComponent as ArrowRightIcon } from 'components/UI/icons/arrow-right-line.svg'
import { NavLink } from 'react-router-dom'

/**
 * Эта компонента представляет собой кнопку "Назад", которая может использоваться как ссылка (<NavLink>) или как обычная кнопка (<div>), в зависимости от переданного свойства type.
 *
 * @param {string} props.type - Тип кнопки ('link' или любое другое значение)
 * @param {function} props.onClick - Функция обратного вызова при клике на кнопку (опционально)
 * @param {string} props.link - Ссылка для кнопки (используется только если type === 'link')
 * @returns {JSX.Element} - JSX элемент компоненты BackButton
 */
const BackButton = ({ type = 'link', onClick, link }) => {
  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }
  return (
    <>
      {type === 'link' ? (
        // Если тип кнопки 'link', создаем NavLink
        <NavLink to={link} className={styles.backButton}>
          <ArrowRightIcon />
        </NavLink>
      ) : (
        // Если тип кнопки не 'link', создаем кнопку с обработчиком клика
        <div className={styles.backButton} onClick={handleClick}>
          <ArrowRightIcon />
        </div>
      )}
    </>
  )
}

export default BackButton
